import { BadgePlain } from "pages/gdt/plain/BadgePlain";

interface ShortTaskIdProps {
  taskId: string;
}
/**
 * A component for rendering a shortened task ID in a badge
 */
export const ShortTaskId = ({ taskId }: ShortTaskIdProps) => {
  return (
    <BadgePlain color="#d3dae6" fontFamily="monospace">
      {taskId.slice(0, 5)}
    </BadgePlain>
  );
};
